
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-[#0E1A2B] shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-8 py-6">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/587d4bfe7b2d3053bc3f394890cbc68c.png" 
              alt="carfuagency" 
              className="h-10 w-auto"
            />
          </a>
          
          <div className="flex items-center gap-12">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-[#F7F5F2] hover:text-[#C8A14A] transition-colors duration-200 text-sm tracking-wide whitespace-nowrap cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('process')}
              className="text-[#F7F5F2] hover:text-[#C8A14A] transition-colors duration-200 text-sm tracking-wide whitespace-nowrap cursor-pointer"
            >
              How It Works
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-[#F7F5F2] hover:text-[#C8A14A] transition-colors duration-200 text-sm tracking-wide whitespace-nowrap cursor-pointer"
            >
              Contact
            </button>
            <button 
              onClick={() => scrollToSection('cta')}
              className="px-6 py-2.5 bg-[#C8A14A] text-[#0E1A2B] text-sm font-medium tracking-wide hover:bg-[#d4af5e] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Request Consultation
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
